import React, { Fragment } from 'react'
import Sidebar from '../Components/Sidebar'
import ProfileHeader from '../Components/Profile/ProfileHeader'
import ProfileFields from '../Components/Profile/ProfileFields'

function Profile() {
    return (
        <Fragment>
            <div class="container-fluid">
                <div className='row'>
                    <div className='col-sm-3 sidebarss'>
                        <Sidebar />
                    </div>
                    <div className='col-sm-9 ssidebar'>
                        <ProfileHeader />
                        <ProfileFields />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Profile